import { render } from "./Videos.vue?vue&type=template&id=46ddc8b6&scoped=true"
import script from "./Videos.vue?vue&type=script&lang=js"
export * from "./Videos.vue?vue&type=script&lang=js"

import "./Videos.vue?vue&type=style&index=0&id=46ddc8b6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-46ddc8b6"

export default script